import { Flex } from '@opendoor/bricks/core';

import QuestionField from 'src/components/layouts/QuestionField';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';
import { useAppSelector } from 'src/store/hooks';
import { getAnswers } from 'src/store/sellerFlow/selectors';

type FollowUpsProps = {
  questions?: Array<FlowQuestion>;
};
const FollowUps: React.FC<FollowUpsProps> = ({ questions }) => {
  const answers = useAppSelector(getAnswers);
  if (questions) {
    return (
      <Flex gap="48px" flexDirection="column">
        {questions.map((question) => {
          return <QuestionField key={question.key} answers={answers} question={question} />;
        })}
      </Flex>
    );
  }
  return null;
};

export default FollowUps;
